<template>
  <div class="map-container">
    <GmapMap
      ref="mapRef"
      :center="center"
      :zoom="zoom"
      map-type-id="roadmap"
      style="width: 100%; height: 100%"
      @click="onMapClick"
      @tilesloaded="addCustomControl"
    >
      <!-- Draw Polyline -->
      <GmapPolyline
        :path="polyline"
        :options="lineOptions"
      />

      <!-- Render Polygons -->
      <GmapPolygon
        v-for="item in polygonGeofences"
        :ref="'polygonGeofence_'"
        :key="item.id"
        :paths="item.path"
        :editable="false"
        :draggable="false"
        :options="polygonOptions"
        @mouseup="onPolygonDragEnd"
      />

      <!-- Render Circles -->
      <GmapCircle
        v-for="item in circleGeofences"
        :ref="'circleGeofence_'"
        :key="item.id"
        :center="item.center"
        :radius="item.radius"
        :editable="true"
        :draggable="true"
        :options="circleOptions"
        @center_changed="onCircleDragEnd"
        @radius_changed="onCircleRadiusChanged(item)"
      />
    </GmapMap>
    <!-- </v-col> -->
    <!-- Hidden control to inject -->
    <div
      v-if="!isGeofence"
      ref="customControl"
      class="custom-map-control"
    >
      <!-- {{ formData }} -->
      <Geofence-form
        v-model="formData"
        type="edit"
        @addGeofence="addGeofence"
        @updateRadius="onCircleRadiusChanged"
        @onSave="onSave"
      />
    </div>
    <!--  -->
    <!-- </v-row> -->
    <!-- </v-container> -->
  </div>
</template>

<script>
import { mapGetters } from "vuex";

let nextId = 1;

export default {
  name: "GeoFenceMap",
  components: {
    GeofenceForm: () => import("../utils/GeofenceForm.vue"),
  },
  data() {
    return {
      center: { lat: 30.3753, lng: 69.3451 },
      zoom: 6,
      //
      formData: {
        circle_radius: 10000,
        points: [],
      },
      geofenceType: "",
      circleRadius: null,

      selectedRow: {},
      //
      movedCenter: [],
      geofences: [],
      //
      lineOptions: {
        // Added line options
        strokeColor: "#4972e7", // Line color
        strokeOpacity: 1.0,
        strokeWeight: 2,
      },
      polygonOptions: {
        fillColor: "#20a390",
        fillOpacity: 0.3,
        strokeColor: "#20a390",
        strokeWeight: 2,
        clickable: false,
        editable: true,
        draggable: false,
        geodesic: true,
        zIndex: 1,
      },
      circleOptions: {
        fillColor: "#20a390",
        fillOpacity: 0.3,
        strokeColor: "#20a390",
        strokeWeight: 2,
        clickable: false,
        editable: true,
        zIndex: 1,
      },
    };
  },

  computed: {
    ...mapGetters({
      authUser: "getUser",
      isGeofence: "geofence/getLoading",
      geofenceList: "geofence/getList",
      tenantsList: "tenantsManagement/getTenantOptions",
    }),
    polyline() {
      // const p = [
      //   { lat: 29.50321915242992, lng: 65.859458073473 },
      //   { lat: "28.291338025600584", lng: "67.111899479723" },
      //   { lat: "27.942505839288206", lng: "69.023520573473" },
      // ];
      if (this.formData.points.length > 0) {
        const pnt = this.formData.points;
        return pnt
          .filter((r) => r.lat && r.lng)
          .map((r) => ({
            lat: parseFloat(r.lat),
            lng: parseFloat(r.lng),
          }));
      } else {
        return [];
      }
    },
    polygonGeofences() {
      return this.geofences.filter((item) => item.type === "polygon");
    },
    circleGeofences() {
      return this.geofences.filter((item) => item.type === "circle");
    },
  },
  watch: {
    "formData.geofence_type"(newVal) {
      if (newVal) {
        setTimeout(() => {
          const map = this.$refs.mapRef.$mapObject;
          map.setOptions({
            draggableCursor: "crosshair", // Change cursor to crosshair
          });
        }, 500);
      }
    },
  },
  async mounted() {
    if (!this.authUser.isAdmin) {
      await this.$store.dispatch("tenantsManagement/options", {});
    }
    await this.getGeofence();
  },

  methods: {
    async getGeofence() {
      const id = this.$route?.params?.id;
      if (id) {
        await this.$store.dispatch("geofence/list").then((res) => {
          const row = res.find((r) => r.id == id);
          this.selectedRow = row;
          const tRow = this.tenantsList.find((r) => r.id == row.tenant_id);
          row.product = tRow?.product;
          row.circle_radius = row.radius;

          // checking for type
          if (row.vehicle_ids?.length > 0) {
            row.type = "vehicles";
            this.getVehicles(row.tenant_id);
          } else if (row.group_ids?.length > 0) {
            row.type = "groups";
            this.getGroups(row.tenant_id);
          }
          // checking for type

          this.formData = { ...this.formData, ...row };

          // checking for geofence

          if (row.center_point?.length > 0 || row.polygon?.length > 0) {
            this.plotGeofence(row);
          }

          // checking for geofence
        });
      } else {
        this.redirectOnList();
      }
    },
    plotGeofence(item) {
      if (item.geofence_type == "circle") {
        const id = nextId++;
        const points = {
          lat: item.center_point[0],
          lng: item.center_point[1],
        };
        this.setMapView(points, item.circle_radius);
        this.geofences.push({
          id,
          type: "circle",
          center: points,
          radius: parseFloat(item.circle_radius),
        });
      } else if (item.geofence_type == "polygon") {
        this.formData.points = item.polygon.map((r) => ({
          lat: r[0],
          lng: r[1],
        }));
        this.addGeofence();
      }
    },
    getVehicles(tId) {
      const params = {
        tenant_id: tId,
      };
      this.$store.dispatch("vehicles/vehicleDropDown", params);
    },
    getGroups(tId) {
      const params = {
        tenant_id: tId,
        // child_group_detail: 1,
      };
      this.$store.dispatch("vehicles/groupDropDown", params);
    },
    onMapClick(e) {
      const latLng = {
        lat: e.latLng.lat(),
        lng: e.latLng.lng(),
      };
      this.geofences = [];

      if (this.formData.geofence_type === "polygon") {
        this.formData.points.push(latLng);
        // this.setMapBounds(this.formData.points);
      } else if (this.formData.geofence_type === "circle") {
        this.formData.points = [];
        this.setMapView(latLng, this.formData.circle_radius);
        const id = nextId++;
        this.geofences.push({
          id,
          type: "circle",
          center: latLng,
          radius: parseFloat(this.formData.circle_radius),
        });
      }
    },
    addGeofence() {
      if (this.formData.geofence_type === "polygon") {
        if (this.formData.points.length >= 3) {
          const id = nextId++;

          this.setMapBounds(this.formData.points);
          this.geofences.push({
            id,
            type: "polygon",
            path: [...this.polyline],
          });
          this.formData.points = [];
        } else {
          this.$store.dispatch(
            "alerts/error",
            "Polygon needs at least 3 points"
          );
        }
      }
    },
    setMapView({ lat, lng }, radius) {
      this.$refs.mapRef.$mapPromise.then((map) => {
        // this.center = { lat, lng };
        // this.zoom = zoomLevel;

        const center = new window.google.maps.LatLng(lat, lng);
        radius = parseFloat(radius);
        const bounds = new window.google.maps.LatLngBounds();
        // Use 4 cardinal points to expand the bounds
        [0, 90, 180, 270].forEach((heading) => {
          const point = window.google.maps.geometry.spherical.computeOffset(
            center,
            radius,
            heading
          );
          bounds.extend(point);
        });

        map.fitBounds(bounds);
      });
    },
    setMapBounds(arr) {
      this.$refs.mapRef.$mapPromise.then((map) => {
        // map is loaded now set  map bound
        if (!arr.length) return;

        const bounds = new window.google.maps.LatLngBounds();

        arr.forEach((v) => {
          bounds.extend(new window.google.maps.LatLng(v.lat, v.lng));
        });

        map.fitBounds(bounds);
        // setTimeout(() => {
        //   let currentZoom = map.getZoom();
        //   map.setZoom(currentZoom - 1); // Zoom out slightly
        // }, 500);
      });
    },
    removeGeofence(id) {
      this.geofences = this.geofences.filter((item) => item.id !== id);
    },
    onPolygonDragEnd() {
      const poly = this.$refs["polygonGeofence_"][0];
      // Access the path from the polygon (it's an MVCArray)
      const path = poly.$polygonObject.getPath();

      // Loop through all the points in the polygon and construct a new array of coordinates
      const updatedPath = [];
      for (let i = 0; i < path.getLength(); i++) {
        const latLng = path.getAt(i);
        updatedPath.push({ lat: latLng.lat(), lng: latLng.lng() });
      }

      // Now updatedPath has the new coordinates
      this.geofences[0].path = updatedPath;
    },

    onCircleDragEnd(v) {
      const latlng = [v.lat(), v.lng()];
      this.movedCenter = latlng;
    },
    onCircleRadiusChanged(v) {
      const refName = "circleGeofence_";
      let circle = this.$refs[refName];

      const obj = circle ? circle[0].$circleObject : null;
      if (obj) {
        if (v.id) {
          this.formData.circle_radius = obj.radius;
        } else if (v) {
          this.geofences[0].radius = parseFloat(v);
          obj.radius = parseFloat(v);
        }
      }
    },
    addCustomControl() {
      const map = this.$refs.mapRef.$mapObject;
      const controlDiv = this.$refs.customControl;

      // Only add if not already added
      if (!this._customControlAdded) {
        map.controls[window.google.maps.ControlPosition.TOP_LEFT].push(
          controlDiv
        );

        this._customControlAdded = true;
      }
    },

    onSave(item) {
      let params = { ...item };
      params.deleted_vehicle_ids = [];
      params.deleted_group_ids = [];

      if (params.type == "vehicles") {
        params.deleted_vehicle_ids = this.selectedRow.vehicle_ids.filter(
          (r) => !params.vehicle_ids.includes(r)
        );
      } else if (params.type == "groups") {
        params.deleted_group_ids = this.selectedRow.group_ids.filter(
          (r) => !params.group_ids.includes(r)
        );
      }
      if (params.geofence_type === "polygon") {
        delete params.circle_radius;
        delete params.points;
        if (this.polygonGeofences.length > 0) {
          params.polygon = this.polygonGeofences[0].path.map((r) => [
            r.lat,
            r.lng,
          ]);
          this.$store.dispatch("geofence/update", params).then(() => {
            this.successMsg();
            this.redirectOnList();
          });
        } else this.$store.dispatch("alerts/error", "Add Polygon Geofence");
      } else if (params.geofence_type === "circle") {
        params.radius = params.circle_radius;
        delete params.circle_radius;
        delete params.points;
        if (this.circleGeofences.length > 0) {
          const center_obj = this.circleGeofences[0].center;
          params.centre =
            this.movedCenter.length > 0
              ? this.movedCenter
              : [center_obj.lat, center_obj.lng];
          this.$store.dispatch("geofence/update", params).then(() => {
            this.successMsg();
            this.redirectOnList();
          });
        } else this.$store.dispatch("alerts/error", "Draw a Circle Geofence");
      }
    },
    successMsg() {
      this.$store.dispatch("alerts/success", this.$t("updated_successfully"));
    },
    async redirectOnList() {
      const qry = await this.$store.dispatch(
        "redirect/getQueryParams",
        "geofence"
      );
      await this.$router.push({ name: "geofence", query: qry });
    },
  },
};
</script>
<style lang="sass" scoped>
.map-container
  position: absolute
  width: 100%
  height: 100%
  top: 0
  left: 0
.custom-map-control
  // user-select: none
  position: absolute !important
  z-index: 99999999 !important
  top: 4rem !important
  left: 1rem !important
  width: 30% !important
  height: 90% !important
  box-shadow: 2px 14px 60px 0px #000
// .column-height
//   height: 90vh !important
</style>
